import AdvanceExpense from '@/components/applications/advance-expense/AdvanceExpense.vue';
import Approvers from '@/components/common/approvers/Approvers.vue';

export default {
  name: 'AdvanceExpenseRequestPreview',
  components: { AdvanceExpense, Approvers },
  props: {
    form: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: null
    }
  },
  data () {
    return {
      dataId: null
    }
  },
  computed: {
    // the eye always shows what was applied for - amount, purpose, bank, approvers;
    // once the report is submitted, its lines follow below the application and the report's title replaces it
    isStatement () {
      return !!this.form?.is_statement;
    },
    previewTitle () {
      return this.isStatement ? this.title : this.$t('applications.advance-expense.title-application');
    },
    applicationValues () {
      return { ...(this.form?.record_fields ?? {}), register_date: this.form?.createdDate };
    },
    submitterName () {
      return this.form?.user?.fullname ?? this.form?.record?.user?.fullname ?? null;
    },
    companyName () {
      const companyId = this.form?.user?.company_id ?? null;
      return companyId ? this.BasicHelper.getConfigValue('user_companies', 'id', companyId, 'name') : null;
    },
    statusCode () {
      if (!this.form?.status_id) {
        return null;
      }
      return this.$store.getters.getDataFromConfigWithFilter(
        'advance_expense_request_statuses', 'id', parseInt(this.form.status_id)
      )?.code ?? null;
    },
    statusName () {
      if (!this.form?.status_id) {
        return null;
      }
      return this.BasicHelper.getConfigValue(
        'advance_expense_request_statuses', 'id', parseInt(this.form.status_id), 'name', true
      );
    },
    statusVariant () {
      if (['REJECTED', 'SUPPORT_REJECTED', 'SUPPORT_CANCELED', 'SUPPORT_BOOK-CANCEL'].includes(this.statusCode)) {
        return 'danger';
      }
      if (['DRAFT', 'CHANGES_NEEDED'].includes(this.statusCode)) {
        return 'warning text-dark';
      }
      if (['APPROVED', 'SUPPORT_APPROVED', 'SUPPORT_BOOKED'].includes(this.statusCode)) {
        return 'success';
      }
      return 'info';
    },
    tableExpandConfig () {
      return { component: 'slot' };
    },
    subTableHeaders () {
      const headers = [
        { key: 'title', label: this.$t('Apraksts') },
        { key: 'amount_without_tax', label: this.$t('Summa bez PVN') },
        { key: 'tax_amount', label: this.$t('PVN') },
        { key: 'currency', label: this.$t('Valūta') },
        { key: 'dimension.division', label: this.$t('Dimensija/Nodaļa'), format: 'formatFromConfig', configKey: 'dimensions_divisions', configParam: 'name' },
        { key: 'dimension.cost_center', label: this.$t('Izmaksu centrs'), format: 'formatFromConfig', configKey: 'dimensions_cost_centers', configParam: 'name' }
      ];
      return headers;
    },
    tableHeaders () {
      const headers = [
        { key: 'id', label: this.$t('N.p.k.'), type: 'slot', slotcode: 'number' },
        { key: 'document_date', label: this.$t('Datums'), type: 'date' },
        { key: 'bill_number', label: this.$t('Čeka/Rēķina nr.') },
        { key: 'reg_no', label: this.$t('Reģ.nr.') },
        { key: 'amount_without_tax', label: this.$t('Dokumenta summa bez PVN') },
        { key: 'tax_amount', label: this.$t('PVN') },
        { key: 'amount', label: this.$t('Kopējā dokumenta summa') },
        { key: 'ax_account_id', label: this.$t('VG kategorija'), format: 'formatFromConfig', configKey: 'ax_accounts', configParam: 'name' },
        { key: 'dimension.division', label: this.$t('Dimensija - Nodaļa'), format: 'formatFromConfig', configKey: 'dimensions_divisions', configParam: 'name' },
        { key: 'dimension.cost_center', label: this.$t('Dimensija - Izmaksu centrs'), format: 'formatFromConfig', configKey: 'dimensions_cost_centers', configParam: 'name' },
        { key: 'payment_document_type_id', label: this.$t('Pamatojums'), format: 'formatFromConfig', configKey: 'advance_expense_document_types', configParam: 'name' }
      ];
      return headers;
    },
    paymentMethods () {
      return this.$store.getters.getConfigOptions('advance_expense_payment_methods', this.$i18n.locale);
    },
    paymentMethodText () {
      return this.paymentMethods.find((el) => el.value == this.form.payment_method_id)?.text;
    },
    id () {
      const id = this.$route.params.id ?? this.dataId;
      if (Number.isInteger(id)) {
        return id;
      }
    },
    componentName () {
      if (this.isModal) {
        return 'b-modal';
      }
      return 'div';
    },
    // @TODO from props
    payoutAmountWithoutTaxTotal () {
      let total = this.form.lines.reduce((amount, line) => {
        return amount + Number(line.amount_without_tax || 0)
      }, 0)
      total = total * 100 / 100;
      return total.toFixed(2);
    },
    payoutAmountTotal () {
      let total = this.form.lines.reduce((amount, line) => {
        return amount + Number(line.payout_amount || 0)
      }, 0)
      total = total * 100 / 100;
      return total.toFixed(2);
    },
    taxAmount () {
      let total = this.form.lines.reduce((amount, line) => {
        return amount + Number(line.tax_amount || 0)
      }, 0)
      total = total * 100 / 100;
      return total.toFixed(2);
    },
    amountTotal () {
      let total = this.form.lines.reduce((amount, line) => {
        return amount + Number(line.amount || 0)
      }, 0)
      total = total * 100 / 100;
      return total.toFixed(2);
    },
    isWithoutId () { // form opened from list
      return this.$route.params.id === 'NEW';
    }
  },
  methods: {
    showModal (el) {
      this.dataId = el.id;
      this.loadData();
      this.$refs['modal-window'].show();
    },
    getLineChildren (lines) {
      return lines.filter((line) => line.send_to_support === true);
    }
  },
  mounted () {
    if (this.id && !this.isWithoutId) {
      this.loadData();
    }
  }
}
